import { IDeliveryNote } from 'commons/types';
import { OUTBOUND_PRINT_TEMPLATE_ROUTES } from 'routes/constants';

export const deliveryNotePrintPDF = async (
  deliveryNote: IDeliveryNote,
): Promise<void> => {
  // since data may large, we store value temporarily in local storage
  // removed upon iframe destroyed
  localStorage.setItem('delivery-note', JSON.stringify(deliveryNote));

  // trigger print
  const printedArea = document.createElement('iframe');
  printedArea.src = `${OUTBOUND_PRINT_TEMPLATE_ROUTES.DELIVERY_NOTE}?&skip-alert-notif=true`;
  printedArea.hidden = true;
  document.body.appendChild(printedArea);
  printedArea.addEventListener('load', () => {
    setTimeout(() => {
      printedArea?.contentWindow?.focus();
      printedArea?.contentWindow?.print();
      setTimeout(() => {
        document.body.removeChild(printedArea);
        localStorage.removeItem('delivery-note');
      }, 2000);
    }, 1000);
  });
};
